import { useSelector } from 'react-redux';
import { EnergyState } from 'store/slices/EnergySlice/types';
import { selectIsRecomputing } from 'store/slices/DsmShadingSlice/selectors';
import { PanelTitle } from '../style';
import UpdatingEstimate from './UpdatingEstimate';

interface Props {
	energy: EnergyState;
}

export default function SystemSize({ energy }: Props) {
	const isShadingAnalysisLoading = useSelector(selectIsRecomputing);
	return <PanelTitle className='system-size'>
		<h4>System Size</h4>
		{isShadingAnalysisLoading
			? <UpdatingEstimate />
			: <h2>{`${(energy.totalNoOfPanelsSelectedByUser * energy.panelCapacityWatts).toFixed(3)} kW`}</h2>
		}
	</PanelTitle>;
}
